<template>
  <div class="emd-stripe">
    <div class="emd-bounds">
      <div class="emd-section">
        <div v-if="isLoading && !requestFailed" class="emd-grid-list">
          <div class="emd-card _state_loading"></div>
          <div class="emd-card _state_loading"></div>
          <div class="emd-card _state_loading"></div>
          <div class="emd-card _state_loading"></div>
        </div>
        <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('home.error')}}</p>
        <div v-else class="emd-grid-list">
          <div class="emd-card column">
            <div class="emd-card__content">
              <router-link :to="{ name: 'createApplication'}">
                <div class="emd-chunk">
                  <div class="emd-text _align_center">
                    <i class="emd-text _color_subtle uil uil-plus-circle" style="font-size: 7rem"></i>
                  </div>
                </div>
                <div class="emd-chunk">
                  <h2 class="emd-text _size_section _color_subtle _align_center">{{ $t('home.add') }}</h2>
                </div>
              </router-link>
            </div>
            <div class="emd-card__footer _paddingless">
              <a href="https://docs.pagar.me/docs/cria%C3%A7%C3%A3o-de-um-app" class="emd-btn _color_secondary _block _sharp _size_big" target="_blank" rel="noopener noreferrer">{{ $t('home.docs') }}</a>
            </div>
          </div>
          <card v-for="(app, index) in apps.items" :key="index" :item="app"></card>
        </div>
        <div v-if="!isLoading" class="emd-section">
          <div class="emd-flex _justify_center">
            <div class="emd-flex-item">
              <button v-show="showLoadMore" class="emd-btn _color_secondary _type_outline" type="button" name="button" @click="paginateApps"> {{ $t('home.app.paginate') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Card from '../components/project/Card.vue'

export default {
  name: 'home',
  components: {
    Card
  },
  computed: {
    apps: function () {
      return this.$store.state.application.apps
    },
    showLoadMore: function () {
      return (this.apps.paging.options.page_count !== this.apps.paging.options.page_number) && this.apps.paging.options.item_count > 10
    }
  },
  data () {
    return {
      isLoading: true,
      requestFailed: false
    }
  },
  methods: {
    paginateApps (e) {
      const element = e.target
      const pageNumber = this.apps.paging.options.page_number + 1
      e.target.classList.add('_state_loading')
      this.$store.dispatch('PAGINATE_APPS', { page: pageNumber, size: 11 })
        .then(() => {
          element.classList.remove('_state_loading')
        })
        .catch(() => {
          element.classList.remove('_state_loading')
        })
    }
  },
  beforeMount () {
    this.$store.dispatch('LIST_APPS', { size: 11 })
      .then(() => {
        this.requestFailed = false
        this.isLoading = false
      })
      .catch(() => {
        this.requestFailed = true
        this.isLoading = false
      })
  }
}
</script>
<style scoped>

  .emd-card._state_loading {
    background-repeat: no-repeat;
    background-image:
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4);
    background-size:
      31% 112px,
      25% 25px,
      20% 22px,
      43% 33px,
      43% 33px;
    background-position:
      0% 0%,
      47% 12%,
      94% 12%,
      8% 92%,
      92% 92%;
    opacity: 1;
    animation: opacity 1s infinite ease-in;
    height: 179px;
  }
  @media (min-width: 768px) {
    .emd-card._state_loading {
      background-size:
        100% 144px,
        50% 25px,
        20% 22px,
        43% 33px,
        43% 33px;
      background-position:
        0% 0%,
        9% 72%,
        94% 72%,
        8% 92%,
        92% 92%;
      height: 253px;
    }
  }
</style>
